import {
  DynamicHeatmapDrawerContextProvider,
  useDynamicHeatmapContext,
} from 'modules/campaignAnalytics/context';
import { Heatmap } from '../Heatmap';
import { LayoutTemplate } from '../LayoutTemplate';
import { HeatmapErrorBanner } from './HeatmapErrorBanner';
import { HeatmapTable } from './HeatmapTable';
import { LegacyHeatmapBanner } from './LegacyHeatmapBanner';
import { TemplatePreview } from './TemplatePreview';

export const DynamicHeatmap = () => {
  const { dynamicLinkStats, rawLinkData, showLegacy, hasTrackingErrors } =
    useDynamicHeatmapContext();
  return (
    <>
      {(dynamicLinkStats?.length > 0 && !showLegacy) ||
      (dynamicLinkStats?.length === 0 && rawLinkData?.length === 0) ? (
        <LayoutTemplate canShowFPOBanner={false} pageName="">
          <LegacyHeatmapBanner />
          {hasTrackingErrors && <HeatmapErrorBanner />}
          <DynamicHeatmapDrawerContextProvider>
            <TemplatePreview />
            <HeatmapTable />
          </DynamicHeatmapDrawerContextProvider>
        </LayoutTemplate>
      ) : (
        <Heatmap showLegacyHeatmapBanner={true} />
      )}
    </>
  );
};
